import React, { useState, useEffect } from 'react';
import { Box, Paper, Typography } from '@mui/material';

interface HtmlEditorProps {
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
    height?: number | string;
}

export const HtmlEditor: React.FC<HtmlEditorProps> = ({
    value,
    onChange,
    placeholder = 'Enter HTML content...',
    height = 300
}) => {
    const [htmlContent, setHtmlContent] = useState(value);

    useEffect(() => {
        setHtmlContent(value);
    }, [value]);

    const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        const newValue = event.target.value;
        setHtmlContent(newValue);
        onChange(newValue);
    };

    return (
        <Box sx={{ display: 'flex', gap: 2, height }}>
            <Paper
                elevation={1}
                sx={{
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    overflow: 'hidden'
                }}
            >
                <Typography
                    variant="subtitle2"
                    sx={{
                        p: 1,
                        backgroundColor: 'grey.100',
                        borderBottom: '1px solid',
                        borderColor: 'divider'
                    }}
                >
                    HTML Editor
                </Typography>
                <textarea
                    value={htmlContent}
                    onChange={handleChange}
                    placeholder={placeholder}
                    maxLength={500000}
                    style={{
                        flex: 1,
                        border: 'none',
                        outline: 'none',
                        padding: '12px',
                        fontFamily: 'Monaco, Menlo, "Ubuntu Mono", Consolas, monospace',
                        fontSize: '14px',
                        lineHeight: 1.5,
                        resize: 'none',
                        backgroundColor: 'transparent'
                    }}
                />
            </Paper>

            <Paper
                elevation={1}
                sx={{
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    overflow: 'hidden'
                }}
            >
                <Typography
                    variant="subtitle2"
                    sx={{
                        p: 1,
                        backgroundColor: 'grey.100',
                        borderBottom: '1px solid',
                        borderColor: 'divider'
                    }}
                >
                    Preview
                </Typography>
                <Box
                    sx={{
                        flex: 1,
                        p: 2,
                        overflow: 'auto',
                        '& *': {
                            maxWidth: '100%'
                        }
                    }}
                    dangerouslySetInnerHTML={{ __html: htmlContent || '<p style="color: #666; font-style: italic;">Preview will appear here...</p>' }}
                />
            </Paper>
        </Box>
    );
};